import { formatZipCode } from "@/helpers/cep-helpers";
import { IAddress } from "@/interfaces/contact.interface";

type UseAdditionalAddressDataReturn = Partial<IAddress> & {
  formattedZipCode: string;
};

type UseAdditionalAddressDataProps = { additionalAddress: IAddress | null };

function useAdditionalAddressData({
  additionalAddress,
}: UseAdditionalAddressDataProps): UseAdditionalAddressDataReturn {
  const formattedZipCode = additionalAddress
    ? formatZipCode(additionalAddress?.addressZipCode)
    : "";

  return { ...additionalAddress, formattedZipCode };
}

export default useAdditionalAddressData;
